/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidUspDocumentCultureinfoQueryResponse>;
